import axios from 'axios';
import { getApiConfig, getApiHeaders, removeApiAuthToken } from './api-helper';
import { JSON_ENCODED, FORM_ENCODED } from '../constants/apiContentTypes';

// https://axios-http.com/docs/interceptors
const addInterceptor = (instance) => {
  instance.interceptors.response.use(
    (response) => response.data,
    (error) => {
      if (error.response?.status === 419 && window.apiAuthToken) {
        removeApiAuthToken();
        window.location.reload();
      }

      return Promise.reject(error.response);
    }
  );
  return instance;
};

const getAxios = (config) => addInterceptor(axios.create(config));

const getAxiosConfig = (baseURL = getApiConfig('Config').baseUrl, headers = getApiHeaders(), withCredentials) => ({
  baseURL,
  headers,
  timeout: 20000,
  withCredentials,
});

// services
export const resyApiGet = ({ authToken, withCredentials } = {}) => getAxios(
  getAxiosConfig(
    getApiConfig('Config').baseRequestUrl,
    getApiHeaders({ authToken }),
    withCredentials
  )
);

export const resyApiPost = ({
  authToken, contentType = FORM_ENCODED, sessionId, withCredentials,
} = {}) => getAxios(
  getAxiosConfig(
    getApiConfig('Config').baseRequestUrl,
    getApiHeaders({ authToken, contentType, sessionId }),
    withCredentials
  )
);

export const resyApiPatch = ({ authToken, contentType = FORM_ENCODED } = {}) => getAxios(
  getAxiosConfig(
    getApiConfig('Config').baseRequestUrl,
    getApiHeaders({ authToken, contentType })
  )
);

export const resyApiDelete = ({ authToken, contentType = FORM_ENCODED } = {}) => getAxios(
  getAxiosConfig(
    getApiConfig('Config').baseRequestUrl,
    getApiHeaders({ authToken, contentType })
  )
);

export const resyBlog = () => axios.create({
  baseURL: 'https://blog.resy.com',
  timeout: 10000,
});

export const ipdata = () => getAxios(
  getAxiosConfig(
    getApiConfig('IpdataConfig').baseRequestUrl,
    { 'Cache-Control': 'no-cache' }
  )
);

export const itemsGet = () => getAxios(
  getAxiosConfig(
    getApiConfig('ItemsServiceConfig').baseRequestUrl,
    getApiHeaders()
  )
);

export const annotationGet = () => getAxios(
  getAxiosConfig(
    getApiConfig('AnnotationServiceConfig').baseRequestUrl,
    getApiHeaders()
  )
);

export const resyOsGet = () => getAxios(
  getAxiosConfig(
    getApiConfig('ResyosServiceConfig').baseRequestUrl
  )
);

export const resyOsPost = ({ contentType = JSON_ENCODED } = {}) => getAxios(
  getAxiosConfig(
    getApiConfig('ResyosServiceConfig').baseRequestUrl,
    getApiHeaders({ contentType })
  )
);

export const resyOsDelete = ({ contentType = JSON_ENCODED } = {}) => getAxios(
  getAxiosConfig(
    getApiConfig('ResyosServiceConfig').baseRequestUrl,
    getApiHeaders({ contentType })
  )
);

export const resySurveyGet = ({ authToken, withCredentials } = {}) => getAxios(
  getAxiosConfig(
    getApiConfig('SurveyServiceConfig').baseRequestUrl,
    getApiHeaders({ authToken }),
    withCredentials
  )
);

export const resySurveyPost = ({ authToken, withCredentials } = {}) => getAxios(
  getAxiosConfig(
    getApiConfig('SurveyServiceConfig').baseRequestUrl,
    getApiHeaders({ authToken }),
    withCredentials
  )
);

export const amexOneDataFunctionsApi = (correlationId) => getAxios(
  getAxiosConfig(
    getApiConfig('ResyAmexConfig').oneDataFunctionUrl,
    {
      'Content-Type': JSON_ENCODED,
      'one-data-correlation-id': correlationId,
    }
  )
);
